import { render, staticRenderFns } from "./submit_with_recaptcha.vue?vue&type=template&id=67948c34&"
import script from "./submit_with_recaptcha.vue?vue&type=script&lang=js&"
export * from "./submit_with_recaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports